<i18n locale="en">
{
  "title": "Uh oh..."
}
</i18n>

<template>
  <DialogHeading :title="$t('title')" v-on="$listeners">
    <template #icon-left>
      <PhWarning size="32" class="status-warning" />
    </template>
  </DialogHeading>
</template>

<script>
import { PhWarning } from 'phosphor-vue/dist/phosphor-vue.esm'

import { DialogHeading } from '@/components/dialogs'

export default {
  name: 'InvalidConfigurationHeader',
  components: { DialogHeading, PhWarning },
}
</script>
